import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';

import {Autocomplete} from "@mui/lab";
import useAuth from "../../hooks/useAuth";
import {Tooltip} from "@mui/material";
import localStrings from "../../localStrings";

const config = require("../../conf/config.json")


function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };
const geocoder = { current: null };

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));

export default function GoogleMapsAutocomplete({title, setValueCallback, initialValue,
                                                 valueSource, setterValueSource, noKeyKnown, countryCode}) {

  const [googleKey, setGoogleKey] = useState('');
  const {getGoogleKey, brand} = useAuth();

  useEffect(() => {
    //setGoogleKey(getGoogleKey());

    if (typeof window !== 'undefined' && !loaded.current) {
      let element = document.querySelector('#google-maps');
      if (element) {
        element.setAttribute("src",
            'https://maps.googleapis.com/maps/api/js?key=' + (noKeyKnown ? config.googleKey :getGoogleKey()) + "&libraries=places");
      }
      else {
        loadScript(
            'https://maps.googleapis.com/maps/api/js?key=' + (noKeyKnown ? config.googleKey :getGoogleKey()) + "&libraries=places",
            document.querySelector('head'),
            'google-maps',
        );
      }
      //if (!document.querySelector('#google-maps')) {

      //}

      loaded.current = true;
    }

  },  [brand])

  const classes = useStyles();
  let [value, setValue] = React.useState(initialValue || '');

  if (valueSource) {
    value = valueSource;
  }
  if (setterValueSource) {
    setValue = setterValueSource;
  }
  // const [locked , setLocked] = useState(lockmode != null)
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);



  const fetch = React.useMemo(
      () =>
          throttle((request, callback) => {
            if (autocompleteService && autocompleteService.current) {
              autocompleteService.current.getPlacePredictions(request, callback);
            }

          }, 200),
      [],
  );

  React.useEffect(() => {
    let active = true;

    if (autocompleteService && !autocompleteService.current && !geocoder.current && window.google) {
      if (window.google.maps.places) {
        autocompleteService.current = new window.google.maps.places.AutocompleteService();
        geocoder.current = new window.google.maps.Geocoder();
      }

    }
    if (!autocompleteService && !autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch(
        {
          input: inputValue,
          componentRestrictions: {country: (countryCode ||brand.country || 'fr')},
        },
        (results) => {
          if (active) {
            let newOptions = [];

            if (value) {
              newOptions = [value];
            }

            if (results) {
              //console.log(JSON.stringify(results, null, 2))
              newOptions = [...newOptions, ...results];
            }
            console.log(JSON.stringify(newOptions, null, 2));
            setOptions(newOptions);
          }
        });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  return (


      <Grid
          container
      >
          {/*<p>{JSON.stringify(options)}</p>*/}
        <Grid
            item
            md={12}
            xs={12}
        >

          <Autocomplete
              // disabled={locked}
              id="google-map-demo"
              fullWidth
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
              filterOptions={(x) => x}
              options={options}
              autoComplete
              includeInputInList
              // filterSelectedOptions
              value={value}
              onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                //console.log("NEW value " + JSON.stringify(newValue, null, 2));
                if (newValue && newValue.place_id) {
                  geocoder.current.geocode({
                    'placeId': newValue.place_id
                  }, (responses, status) => {
                    if (status == 'OK') {
                      let lat = responses[0].geometry.location.lat();
                      let lng = responses[0].geometry.location.lng();

                      if (setValueCallback) {
                        setValueCallback(
                            newValue.description,
                            newValue.place_id,
                            null,
                            null,
                            null,
                            lat,
                            lng
                        )
                      }
                      //console.log(lat, lng);
                    }
                  })
                }
              }}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              inputProps={{
                autocomplete: 'new-password',
              }}

              renderInput={(params) => (
                  // <form noValidate>
                  <form autoComplete="off">
                    <TextField {...params}
                               autocomplete="off"
                               label={title || localStrings.address}
                               variant="standard"
                               // value={title}
                               fullWidth />
                  </form>
              )}
              // renderOption={(props, option) => {
              //    let data = options.find(o => o.place_id === option.key);
              //
              //   if (!data || !data.structured_formatting) {
              //     return;
              //   }
              //   const matches = data.structured_formatting.main_text_matched_substrings;
              //   const parts = parse(
              //       data.structured_formatting.main_text,
              //       matches.map((match) => [match.offset, match.offset + match.length]),
              //   );
              //
              //   return (
              //       <Grid container alignItems="center">
              //         <Grid item>
              //           <LocationOnIcon className={classes.icon} />
              //         </Grid>
              //         <Grid item xs>
              //           {parts.map((part, index) => (
              //               <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
              //     {part.text}
              //   </span>
              //           ))}
              //
              //             <Typography variant="body2" color="textSecondary">
              //                 {data.structured_formatting.secondary_text}
              //             </Typography>
              //         </Grid>
              //
              //
              //       </Grid>
              //   );
              // }}
          />



        </Grid>

        {/*{lockmode &&*/}
        {/*    <Grid*/}
        {/*        item*/}
        {/*        md={1}*/}
        {/*        xs={1}*/}
        {/*    >*/}

        {/*      <Tooltip title={locked ? localStrings.unlock : localStrings.lock}>*/}
        {/*        <IconButton aria-label="delete" onClick={() => setLocked(!locked)}>*/}
        {/*          <LockOpenIcon fontSize="large" />*/}
        {/*        </IconButton>*/}
        {/*      </Tooltip>*/}
        {/*    </Grid>*/}
        {/*}*/}

      </Grid>



  );
}


